import '../css-sanitization/doppe-viewer-sanitize.st.css'
import './doppe-user-app-client-bootstrap.st.css'
import React from 'react';
import {reactHydrate, reactRender} from '@wix/devzai-utils-react';
import {DoppeViewerInvocationSource, DoppeViewerPageTypes} from '../../client-server-common';
import {asyncExecuteInBackground, evaluateFunction} from '@wix/devzai-utils-common';
import {
    doppeViewerClientServicesInitialize,
    DoppeViewerClientServicesReactContext
} from './doppe-viewer-client-services';
import {bymoPageViewerPageAsyncCreate} from '../doppe-viewer-pages/bymo-page-viewer-page/bymo-page-viewer-page';
import {
    bymoPageViewerModeResolveFromViewerPageData
} from '../../components/bymo-page-viewer-context/bymo-page-viewer-context';
import {
    doppeDtoBymoLinkViewerDataResolvePageType
} from '../../client-server-common/types/doppe-dto-bymo-link-viewer-data';
import {doppeViewerPageInfoCreateHome} from '../../client-server-common/viewer-pages/doppe-viewer-pages';
import {BrowserHistory} from '@wix/devzai-common-client';
import {browserIsIframeWindow} from '@wix/devzai-utils-browser';

export function doppeUserAppClientBootstrap () {

    const rootContainerId = 'SITE_MAIN';
    const container = document.getElementById(rootContainerId) ??
        (() => {
            const newContainer = document.createElement('div');
            newContainer.id = rootContainerId;
            document.body.appendChild(newContainer);
            return newContainer;
        })();


    const clientServices = doppeViewerClientServicesInitialize();

    if (clientServices.doppeUserAppData.devEnabled) {
        void evaluateFunction(async () => {
            Object.assign(window, {
                $dev: {
                    clientServices: clientServices,
                    ...(await import('./doppe-user-app-client-dev')).doppeUserAppClientDevCreate(clientServices),
                }
            })
        })
    }

    void asyncExecuteInBackground(async () => {

        const pageComponent = await evaluateFunction(async () => {

            try {
                const currentPathPageData = evaluateFunction(() => {
                    const currentPathPageData = __doppe_viewer_app_data__.pageData;

                    if (!currentPathPageData) {
                        throw new Error(`Page data is not available`);
                    }

                    if (currentPathPageData.pageType !== DoppeViewerPageTypes.BymoPage) {
                        throw new Error(`Unsupported viewer page type: ${currentPathPageData.pageType}`);
                    }

                    return currentPathPageData;
                })

                // TODO: Currently I don't initialize the browser history for pre-roll pages to avoid a conflict
                // TODO: with initializeSkipOnBackBehaviour. I should see if they can co-exist.
                if (currentPathPageData.invocationSource === DoppeViewerInvocationSource.DoppeApp ? !browserIsIframeWindow(window) : true) {
                    if (!currentPathPageData.bymoLinkViewerData.targetUrl) {
                        BrowserHistory.initialize();
                    }
                }

                const bymoLinkViewerData = currentPathPageData.bymoLinkViewerData;

                clientServices.bymoService.initialize({
                    bymoLinkViewerData: bymoLinkViewerData
                });

                clientServices.doppeViewerAppCookieService.initialize();

                clientServices.viewerAnalyticsClient.initialize({
                    bymoLinkViewerData: bymoLinkViewerData,
                    reportAnalyticsEvents: currentPathPageData.invocationSource !== DoppeViewerInvocationSource.DoppeApp && !currentPathPageData.isPreviewMode
                });

                clientServices.viewerBmAnalyticsDashboardBiClient.initialize({
                    bymoLinkViewerData: bymoLinkViewerData,
                    reportAnalyticsEvents: currentPathPageData.invocationSource !== DoppeViewerInvocationSource.DoppeApp && !currentPathPageData.isPreviewMode
                });

                if (currentPathPageData.invocationSource !== DoppeViewerInvocationSource.DoppeApp) {
                    const livePageData = {
                        linkId: bymoLinkViewerData.linkId,
                        bymoPageId: bymoLinkViewerData.bymoPageId,
                        doppeUserId: bymoLinkViewerData.doppeUserId,
                        pageType: doppeDtoBymoLinkViewerDataResolvePageType(bymoLinkViewerData)
                    };

                    if (bymoLinkViewerData.targetUrl) {
                        clientServices.bymoService.initializeSkipOnBackBehaviour({
                            targetUrl: bymoLinkViewerData.targetUrl,
                            livePageData: livePageData
                        });
                    }

                    clientServices.bymoService.initializePageListeners({
                        livePageData: livePageData,
                        logUserActivityEvent: false,
                        targetUrl: bymoLinkViewerData.targetUrl,
                    })
                }

                // Initialize router service FIRST with bymoPageProps
                // Note: Router works alongside existing modal back button interception
                // Priority: Modals (Infinity) > Router (default) > Browser default
                clientServices.viewerRouterClientService.initialize({
                    bymoPageProps: bymoLinkViewerData.pageData.bymoPageProps,
                    // Skip BrowserHistory operations in preview mode to avoid triggering editor's unsaved changes modal
                    isPreviewMode: currentPathPageData.isPreviewMode
                    // initialPageInfo is set by initialize() from current URL
                });

                // Get initial page info from router (now that it's initialized with bymoPageProps)
                const initialPageInfo = clientServices.viewerRouterClientService.getCurrentPageInfo() ?? 
                    doppeViewerPageInfoCreateHome();

                // Pass the page info to the viewer
                return await bymoPageViewerPageAsyncCreate({
                    actionTypesStore: clientServices.actionTypesStore,
                    bymoTemplatesStore: clientServices.bymoTemplatesStore,
                    bymoLinkViewerData: bymoLinkViewerData,
                    mode: bymoPageViewerModeResolveFromViewerPageData(currentPathPageData),
                    currentPageInfo: initialPageInfo
                })
            } catch (error) {
                console.error(error);
                return (<div/>);
            }
        });

        const app = (
            <DoppeViewerClientServicesReactContext.Provider
                value={clientServices}
            >
                {pageComponent ?? (<div/>)}
            </DoppeViewerClientServicesReactContext.Provider>
        )

        if (container.hasAttribute('data-ssr')) {
            console.log('ssr available - hydrating root container...');

            reactHydrate(container, app);
        } else {
            console.log('no ssr - rendering root container...');

            reactRender(container, app);
        }

    }, {
        onError: error => {
            console.error(`Failed loading page`, error)
        }
    })
}
